import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  success: false,
  error: null,
  message: null,
  inventories: [],
  inventory: null,
};

export const inventoryReducer = createReducer(initialState, (builder) => {
  builder
    // Inventory Creation
    .addCase('inventoryCreateRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('inventoryCreateSuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
      state.success = true;
    })
    .addCase('inventoryCreateFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Fetch All Inventories
    .addCase('getAllInventoriesRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllInventoriesSuccess', (state, action) => {
      state.isLoading = false;
      state.inventories = action.payload;
    })
    .addCase('getAllInventoriesFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Search Inventories
    .addCase('searchInventoriesRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('searchInventoriesSuccess', (state, action) => {
      state.isLoading = false;
      state.inventories = action.payload.inventories;
      state.success = true;
    })
    .addCase('searchInventoriesFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Find Inventory by UPC
    .addCase('findInventoryByUPCRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('findInventoryByUPCSuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
      state.success = true;
    })
    .addCase('findInventoryByUPCFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Fetch Single Inventory
    .addCase('getSingleInventoryRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getSingleInventorySuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
    })
    .addCase('getSingleInventoryFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Edit Inventory
    .addCase('editInventoryRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('editInventorySuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
      state.success = true;
    })
    .addCase('editInventoryFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Update inventory variants
    .addCase('updateInventoryVariantRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateInventoryVariantSuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
      state.success = true;
    })
    .addCase('updateInventoryVariantFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Update inventory variations
    .addCase('updateInventoryVariationsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateInventoryVariationsSuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
      state.success = true;
    })
    .addCase('updateInventoryVariationsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Update primary variants
    .addCase('updatePrimaryVariantsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updatePrimaryVariantsSuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
      state.success = true;
    })
    .addCase('updatePrimaryVariantsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Update secondary variants
    .addCase('updateSecondaryVariantsRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('updateSecondaryVariantsSuccess', (state, action) => {
      state.isLoading = false;
      state.inventory = action.payload;
      state.success = true;
    })
    .addCase('updateSecondaryVariantsFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Fetch Inventory by Store
    .addCase('getInventoryByStoreRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getInventoryByStoreSuccess', (state, action) => {
      state.isLoading = false;
      state.inventories = action.payload;
    })
    .addCase('getInventoryByStoreFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Delete Inventory
    .addCase('deleteInventoryRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteInventorySuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
    })
    .addCase('deleteInventoryFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // Transfer Inventory
    .addCase('transferInventoryRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('transferInventorySuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase('transferInventoryFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Add Inventory
    .addCase('addInventoryRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('addInventorySuccess', (state, action) => {
      state.isLoading = false;
      state.message = action.payload;
      state.success = true;
    })
    .addCase('addInventoryFailed', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })
    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })
    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});
